import MetaText from "../MetaText";
import { siteMetadata } from "../../../content/siteMetadata";

/**
 * Shared legal bar rendered at the bottom of every footer variant.
 * Carries the copyright notice and the public Trust Center link.
 * Traducción: Barra legal compartida con el aviso de copyright y el enlace al Trust Center.
 *
 * @returns {JSX.Element} Footer legal bar.
 */
const FooterLegal = () => {
  const currentYear = new Date().getFullYear();
  const { siteName, trustCenter } = siteMetadata;

  console.log("[LOG] - Rendering footer legal bar:", {
    currentYear,
    trustCenterHref: trustCenter.href,
  });

  return (
    <div className="site-footer__legal">
      <MetaText>
        &copy; {currentYear} {siteName}. All rights reserved.
      </MetaText>
      <a
        href={trustCenter.href}
        target="_blank"
        rel="noopener noreferrer"
        className="site-footer__legal-link"
        title={trustCenter.description}
      >
        <MetaText>{trustCenter.label}</MetaText>
      </a>
    </div>
  );
};

export default FooterLegal;
